"use strict";

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked to add a product to the wishlist
 */
function displayMessage(data, button) {
    $.spinner().stop();
    const $wishlistToast = $("#toast-wishlist-toast");

    if ($wishlistToast.length > 0) {
        $wishlistToast.find(".toast-body").html(data.msg);

        if (data.success) {
            $wishlistToast.find(".toast-body").removeClass("ti-text-color-red ti-toast-invalid");
            button.addClass("filled");
        } else {
            $wishlistToast.find(".toast-body").addClass("ti-text-color-red ti-toast-invalid");
        }

        $wishlistToast.toast("show");
    }
}

module.exports = {
    addToWishlist: function () {
        $(document).off("click touchstart", "[data-add-to-wishlist]").on("click touchstart", "[data-add-to-wishlist]", function (e) {
            e.preventDefault();
            const url = $(this).data("href");
            const button = $(this);
            const pid = $(this).closest(".product").data("pid") || $(this).closest(".product-detail").data("pid");
            let optionId = $(this).closest(".product-detail").find(".product-option").attr("data-option-id");
            let optionVal = $(this).closest(".product-detail").find(".options-select option:selected").attr("data-value-id");
            optionId = optionId || null;
            optionVal = optionVal || null;
            if (!url || !pid) {
                return;
            }

            $.spinner().start();
            $(this).attr("disabled", true);
            $.ajax({
                url: url,
                type: "post",
                dataType: "json",
                data: {
                    pid: pid,
                    optionId: optionId,
                    optionVal: optionVal
                },
                success: function (data) {
                    displayMessage(data, button);
                    var cbtEvent = $(document).find("[data-cbt-product-id='" + pid + "']");
                    if (cbtEvent.length > 0) {
                        cbtEvent[0].click();
                    }

                    button.attr("aria-pressed", "true");
                },
                error: function (err) {
                    displayMessage(err, button);
                }
            });
        });
    }
};
